import Button from '../layout/Button';
import Container from '../layout/Container';
import Header from '../layout/Header';
import MainContent from '../layout/MainContent';


function NotFound() {
    return <Container>
        <Header></Header>
        <MainContent>
            <h2 className="page-title">הדף לא נמצא</h2>
            <Button to="/" className="big fullwidth"><i className="fas fa-home"></i> לחזור הביתה</Button>
        </MainContent>
    </Container>
}

export default NotFound;